/* =========================================================
   DOPAMEAN — Product-title polish:
   1. Replace " - " with " • "
   2. Convert ALL-CAPS titles to Title Case (first letter of each
      word capitalised, rest lowercase).
   Only touches elements that hold product names (cards, product
   page, cart items, breadcrumb current page), so hyphenated words
   like "T-shirt" elsewhere on the page are untouched.
   ========================================================= */
(function () {
  // Selectors for every place a product title can appear
  const SELECTORS = [
    '.card__heading',
    '.card__heading a',
    '.product__title h1',
    '.product__title h2',
    '.product__title .h1',
    'product-info .product__title h1',
    'product-info .product__title h2',
    'product-info h1',
    '.cart-item__name',
    '.cart-item__name a',
    '.cart-item__details a',
    '.dpm-breadcrumbs__current',
    '.dpm-stack__card-title',
    '.dpm-banner__heading',
  ];

  const HYPHEN_SEP = / - /g;
  const BULLET     = ' • ';
  /* Versioned attribute so any stale `data-dpm-bulleted="1"` from an
     earlier script that only did bullet replacement won't make the new
     title-cased transform skip those elements. */
  const PROCESSED_ATTR = 'data-dpm-titled-v2';

  // Title-case the part BEFORE the bullet: lowercase the whole string,
  // then uppercase the first letter at the start or after any whitespace.
  // Letters after apostrophes/hyphens stay lower so "men's" → "Men's"
  // and "t-shirt" → "T-shirt".
  function toTitleCase(str) {
    return str
      .toLowerCase()
      .replace(/(^|\s)([a-zÀ-ɏ])/g, function (_m, p1, p2) {
        return p1 + p2.toUpperCase();
      });
  }

  // Apply the full title transform:
  //   • Convert " - " separators to " • "
  //   • Title-case the part before the first bullet
  //   • Keep everything AFTER the bullet in ALL CAPS
  //     (size codes like "XL", "M", "EU 42")
  function transformTitle(raw) {
    var str = raw.replace(HYPHEN_SEP, BULLET);
    var idx = str.indexOf(BULLET);
    if (idx === -1) {
      return toTitleCase(str);
    }
    var head = str.slice(0, idx);
    var tail = str.slice(idx + BULLET.length);
    return toTitleCase(head) + BULLET + tail.toUpperCase();
  }

  // Walk text nodes inside the given element and apply the transform.
  function bulletify(el) {
    if (!el || el.getAttribute(PROCESSED_ATTR) === '1') return;
    const walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT, null);
    let node;
    while ((node = walker.nextNode())) {
      if (!node.nodeValue) continue;
      const transformed = transformTitle(node.nodeValue);
      if (transformed !== node.nodeValue) {
        node.nodeValue = transformed;
      }
    }
    el.setAttribute(PROCESSED_ATTR, '1');
  }

  function run(root) {
    const scope = root || document;
    SELECTORS.forEach((sel) => {
      scope.querySelectorAll(sel).forEach(bulletify);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => run());
  } else {
    run();
  }
  // One follow-up pass after web fonts / hydration settle.
  window.addEventListener('load', () => run());

  // Re-run after Shopify section / cart drawer refresh
  document.addEventListener('shopify:section:load', (e) => {
    if (e.target && e.target.querySelectorAll) run(e.target);
  });

  // Cart drawer updates the cart-items list via innerHTML swap
  const cartDrawer = document.querySelector('cart-drawer, #CartDrawer');
  if (cartDrawer && typeof MutationObserver !== 'undefined') {
    let scheduled = false;
    new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        run(cartDrawer);
      });
    }).observe(cartDrawer, { childList: true, subtree: true });
  }

  // <product-recommendations> fetches its products async after load —
  // observe it so bullets render once the cards are injected.
  if (typeof MutationObserver !== 'undefined') {
    document.querySelectorAll('product-recommendations').forEach((rec) => {
      let scheduled = false;
      new MutationObserver(() => {
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          run(rec);
        });
      }).observe(rec, { childList: true, subtree: true });
    });
  }

  // <product-info> can re-render the title (and other blocks) when a
  // variant changes. Re-process whenever its subtree mutates so the
  // newly-painted title gets the same casing applied.
  if (typeof MutationObserver !== 'undefined') {
    document.querySelectorAll('product-info').forEach((pi) => {
      let scheduled = false;
      new MutationObserver((muts) => {
        // Clear the processed flag on titles so they get re-cased after
        // any re-render — variant picker can swap text content without
        // touching the wrapping element's data attribute.
        pi.querySelectorAll(
          '.product__title h1, .product__title h2, .product__title .h1'
        ).forEach((el) => el.removeAttribute(PROCESSED_ATTR));
        if (scheduled) return;
        scheduled = true;
        requestAnimationFrame(() => {
          scheduled = false;
          run(pi);
        });
      }).observe(pi, { childList: true, subtree: true, characterData: true });
    });
  }
})();
